module.exports = __webpack_public_path__ + "8df72686b6dc2205cb5b26887ebb55a1.woff2";